export default [
    {
        id: 'layout_24_1',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644332944319795.png',
        url: 'https://opensea.io/',
        url_name: 'Opensea',
        tip: '最大的NFT交易市场，天下苦Opensea久已'
    },
    {
        id: 'layout_24_2',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644328397847935.png',
        url: 'https://dappradar.com/nft',
        url_name: 'Dappradar',
        tip: '全球Dapp商店'
    },
    { 
        id: 'layout_24_3',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220205/1644038835852384.png',
        url: 'https://nftgo.io/whale-tracking/trade',
        url_name: '巨鲸跟踪',
        tip: '监控巨鲸买NFT动向的网站'
    },
    {
        id: 'layout_24_4',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220205/1644039006687941.png',
        url: 'https://icodrops.com/',
        url_name: 'ICO预告',
        tip: '获取最新ICO预告信息'
    },
    {
        id: 'layout_24_5',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644289410267198.png',
        url: 'https://debank.com/',
        url_name: '钱包监控',
        tip: '关注巨鲸、机构钱包地址监控，发现最新投资标的'
    },
    {
        id: 'layout_24_6',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644332774801106.png',
        url: 'https://coinmarketcap.com/',
        url_name: 'CoinMarketCap',
        tip: '全面的币种价格信息'
    },
    {
        id: 'layout_24_7',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644333261593995.png',
        url: 'https://www.binance.com/en',
        url_name: 'Binance',
        tip: '币安交易所'
    },
    {
        id: 'layout_24_8',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220127/1643288452198152.png',
        url: 'https://info.uniswap.org/#/',
        url_name: 'Uniswap',
        tip: 'DEX交易'
    },
    {
        id: 'layout_24_9',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220208/1644331416233798.png',
        url: 'https://etherscan.io/',
        url_name: 'ETH浏览器',
        tip: '以太坊官方区块浏览器'
    },
    {
        id: 'layout_24_10',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220128/1643372040507819.png',
        url: 'https://metamask.io/',
        url_name: 'MetaMask',
        tip: '浏览器钱包插件'
    },
    {
        id: 'layout_24_11',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220210/1644425051955333.png',
        url: 'https://www.defipulse.com/',
        url_name: 'Defi Pulse',
        tip: '以太坊Defi项目排行榜'
    },
    {
        id: 'layout_24_12',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220207/1644198473616858.png',
        url: 'https://mirror.xyz/',
        url_name: 'mirror',
        tip: ''
    },
    {
        id: 'layout_24_13',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220205/1644039651470007.png',
        url: 'https://www.theblockresearch.com/',
        url_name: '行业研报',
        tip: '顶级行业研究报告，定期更新'
    },
    {
        id: 'layout_24_14',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220301/1646099664398016.png',
        url: 'https://www.odaily.news/',
        url_name: 'odaily',
        tip: '星球日报，高质量中文新闻'
    },
    {
        id: 'layout_24_15',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220127/1643294329983296.png',
        url: 'https://www.nansen.ai/',
        url_name: 'Nansen',
        tip: '跟聪明钱投项目，链上数据跟踪平台（付费）'
    },
    {
        id: 'layout_24_16',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220203/1643897555791203.jpg',
        url: 'https://www.nftscan.com/',
        url_name: 'NFTSCAN',
        tip: '专业的NFT浏览器和数据分析平台'
    },
    {
        id: 'layout_24_17',
        url_img: 'https://tool.imtoken.xyz/static/upload/image/20220203/1643893639390275.png',
        url: 'https://tokentool.app/createToken/eth',
        url_name: '一键发币',
        tip: '一键发行ETH、BSC等资产，低成本小白可用'
    }
]